/* unplugin-vue-components disabled */import script from "./SPCErrorPop.vue?vue&type=script&setup=true&lang=js"
export * from "./SPCErrorPop.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__